import { fadeInSelf } from "./fadeInAni_self";
import { fadeInTop } from "./fadeInAni_top";

// export 文を使って関数 greet1 を定義
export const tabAction = () => {
  $(function () {
    const tabs = $(".js-tab-btn");

    $(".js-tab-btn").on("click", function () {
      // タブ切り替え
      $(".is-tab-active").removeClass("is-tab-active");
      $(this).addClass("is-tab-active");

      const index = tabs.index(this);
      const sectNo = "sect0"; // 推奨
      const headerH = $("header").outerHeight() || 0;
      const speed = 500;

      $(".js-tab-target")
        .removeClass("is_tab_show")
        .eq(index)
        .addClass("is_tab_show");

      $(".js-sp-footer-btn")
        .removeClass("is_btn_show")
        .eq(index)
        .addClass("is_btn_show");

      // アニメーション再初期化
      fadeInTop();
      fadeInSelf();

      // スムーススクロール
      const $target = $("#" + sectNo);
      if ($target.length) {
        const position = $target.offset().top - headerH;
        $("html, body").animate({ scrollTop: position }, speed);
      }
    });
  });
};
